/**
 * Verifica si el usuario tiene permisos para acceder a un módulo específico.
 * @param {*} props - Props desde redux, incluyendo el usuario.
 * @param {*} nombreModulo - Nombre del módulo a verificar.
 * @returns {void} - Redirige a la página de error si no tiene permisos.
 */
export const verificarPermisosModulo = (props, nombreModulo) => {
    const { me: user } = props;
    if (user) {
        const permisos = user.rol_usuario;
        if (!permisos || !permisos[nombreModulo]) {
            props.history.push('/not-found');
        }
    } else {
        props.history.push('/not-found');
    }
}
